exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".v-time-picker-custom .v-picker__title {\n  height: 84px;\n  padding-top: 10px;\n}\n", ""]);
